"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreTagsPostAsyncSlice = void 0;
const add_1 = require("./add.js");
const name_1 = require("./name.js");
const api_1 = require("../../api/index.js");
const actions_1 = require("./_idMap/actions.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreTagsPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.TAG_CREATED, (action) => ({ name: action.data.name })),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => add_1.coreAddTagsSyncSlice.syncActionCreator({
                autoTagged: false,
                description: request.description,
                hexColor: request.hexColor,
                id: response.sonarObjectTagId,
                name: request.name,
                ownerIds: request.ownerIds
            }),
            (request, response) => (0, actions_1.updateTagReferences)([
                {
                    autoTagged: false,
                    description: request.description,
                    hexColor: request.hexColor,
                    id: response.sonarObjectTagId,
                    name: request.name,
                    ownerIds: request.ownerIds
                }
            ])
        ]
    },
    name: name_1.CoreTagsName,
    receive: true,
    request: true,
    requestHandler: api_1.postTag
});
//# sourceMappingURL=post.js.map